const GLASS_STROKE = '#6f8db3';
const GLASS_FILL = 'rgba(255, 255, 255, 0.55)';
const SHELF_TOP = 62;

/**
 * Round-bottomed volumetric flask: a bulb with a long thin neck, a fill line and a stopper.
 */
function VolumetricFlask({ x, liquidColor }) {
  const bulbCenterY = SHELF_TOP - 10;
  return (
    <g>
      <circle cx={x} cy={bulbCenterY} r="10" fill={GLASS_FILL} stroke={GLASS_STROKE} strokeWidth="1.5" />
      <path d={`M${x - 9.5} ${bulbCenterY + 3} A10 10 0 0 0 ${x + 9.5} ${bulbCenterY + 3} Z`} fill={liquidColor} opacity="0.85" />
      <rect x={x - 2.5} y="22" width="5" height="21" fill={GLASS_FILL} stroke={GLASS_STROKE} strokeWidth="1.5" />
      <path d={`M${x - 4} 30 H${x + 4}`} stroke={GLASS_STROKE} strokeWidth="1" />
      <rect x={x - 3.5} y="18" width="7" height="5" rx="1.5" fill="#8aa0c0" />
    </g>
  );
}

/**
 * Small conical (Erlenmeyer) flask.
 */
function SmallConicalFlask({ x, liquidColor }) {
  return (
    <g>
      <path
        d={`M${x - 3.5} 32 V41 L${x - 11} ${SHELF_TOP - 1} H${x + 11} L${x + 3.5} 41 V32 Z`}
        fill={GLASS_FILL}
        stroke={GLASS_STROKE}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d={`M${x - 7.5} 52 H${x + 7.5} L${x + 10.5} ${SHELF_TOP - 1.5} H${x - 10.5} Z`} fill={liquidColor} opacity="0.85" />
      <rect x={x - 5} y="30" width="10" height="3" rx="1.5" fill={GLASS_STROKE} />
    </g>
  );
}

/**
 * Small beaker with a pouring spout and measuring marks.
 */
function SmallBeaker({ x, liquidColor }) {
  return (
    <g>
      <rect x={x - 8.5} y="48" width="17" height="13" fill={liquidColor} opacity="0.85" />
      <path
        d={`M${x - 11} 38 L${x - 9} 40 V${SHELF_TOP - 2} Q${x - 9} ${SHELF_TOP} ${x - 7} ${SHELF_TOP} H${x + 7} Q${x + 9} ${SHELF_TOP} ${x + 9} ${SHELF_TOP - 2} V38`}
        fill={GLASS_FILL}
        stroke={GLASS_STROKE}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d={`M${x + 4} 45 H${x + 8} M${x + 4} 50 H${x + 8} M${x + 4} 55 H${x + 8}`} stroke={GLASS_STROKE} strokeWidth="1" />
    </g>
  );
}

/**
 * Glassware on the top-left lab shelf: a volumetric flask, a conical flask and a beaker.
 */
export default function ShelfGlassware() {
  return (
    <>
      <VolumetricFlask x={38} liquidColor="#ff8a78" />
      <SmallConicalFlask x={67} liquidColor="#7fb6ff" />
      <SmallBeaker x={95} liquidColor="#9be070" />
    </>
  );
}
